import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login.vue'
import Layout from '@/components/Layout.vue'
import Account from '@/components/Account.vue'
import User from '@/components/User.vue'
import City from '@/components/City.vue'
import SysNotice from '@/components/SysNotice.vue'
Vue.use(Router)

export default new Router({
  routes: [
   
    {
      path: '/',
      name: 'Login',
      component: Login
    }, {
      path: '/Login',
      name: 'Login',
      component: Login
    }, 
    {
      path: '/layout',
      name: 'layout',
      component: Layout,
      children: [
        {
          path: 'account',
          name: 'account',
          component: Account
        },{
            path: 'user',
            name: 'user',
            component: User
          },{
            path: 'city',
            name: 'city',
            component: City
          },{
            path: 'sys_notice',
            name: 'sys_notice',
            component: SysNotice
          }
      ]
    }
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js